export const ConnectTypeDecorator = {
  url() {
    return `signup-hubspot/connect`;
  },

  query() {
    return {};
  }

};